export default class MeigaranewsrecentlService {
  getNewsInfo(code) {
    return fetch("https://api.tradersr.com/api/meigaranewsrecentl?code=" + code)
      .then(res => res.json());
  }
}